export default __webpack_public_path__ + "static/media/hot_tub.b24cb184.svg";